const de = {
  recent: 'Zuletzt besucht',
  licenseKey: 'Lizenzschlüssel',
  licenseKeyHint: 'Zum Erstellen eines Kontos nötig. Jeder Schlüssel funktioniert für genau ein Konto. Beim Anmelden brauchst du ihn nicht.',
  lic_required: 'Bitte gib einen Lizenzschlüssel ein.',
  lic_not_found: 'Dieser Lizenzschlüssel ist ungültig.',
  lic_used: 'Dieser Lizenzschlüssel wurde schon für ein Konto benutzt.',
  lic_suspended: 'Dieser Lizenzschlüssel ist pausiert.',
  lic_revoked: 'Dieser Lizenzschlüssel wurde widerrufen.',
  lic_expired: 'Dieser Lizenzschlüssel ist abgelaufen.',
  lic_activation_limit_reached: 'Für diesen Lizenzschlüssel ist das Limit erreicht.',
  lic_wrong_product: 'Dieser Lizenzschlüssel gehört zu einem anderen Produkt.',
  lic_unreachable: 'Der Lizenzserver ist gerade nicht erreichbar. Versuch es gleich noch einmal.',
  general: 'Allgemein',
  browsingMode: 'Browser-Modus',
  browsingModeHint: 'Direkt lädt Seiten auf deinem Gerät (schnell). Cloud läuft isoliert auf dem Server.',
  modeDirectOpt: 'Direkt (schnell)',
  modeCloudOpt: 'Cloud (isoliert)',
  offerSavePw: 'Anbieten, Passwörter zu speichern',
  offerFillPw: 'Gespeicherte Zugangsdaten zum Ausfüllen anbieten',
  passwords: 'Passwörter',
  passwordsHint: 'Gespeichert und verschlüsselt in deinem Konto. Im Cloud-Modus werden Anmeldungen automatisch erkannt.',
  noPasswords: 'Noch keine gespeicherten Passwörter.',
  addPassword: 'Passwort hinzufügen',
  website: 'Website',
  username: 'Benutzername',
  password: 'Passwort',
  show: 'Anzeigen',
  hide: 'Verbergen',
  copyPw: 'Passwort kopieren',
  deleteBtn: 'Löschen',
  saveBtn: 'Speichern',
  updateBtn: 'Aktualisieren',
  neverBtn: 'Nie',
  neverSavedFor: 'Nie speichern für',
  removeBtn: 'Entfernen',
  savePwQ: 'Passwort speichern für',
  updatePwQ: 'Passwort aktualisieren für',
  fillAs: 'Ausfüllen als',
  pwSaved: 'Passwort gespeichert',
  siteData: 'Websitedaten',
  siteDataHint: 'Cookies, Passwörter und Berechtigungen pro Website. Hier kannst du Daten ausgewählter Websites löschen.',
  cookiesCol: 'Cookies',
  passwordsCol: 'Passwörter',
  permissionsCol: 'Berechtigungen',
  deleteSelected: 'Ausgewählte löschen',
  deleteEverything: 'Alles löschen',
  alsoPasswords: 'Auch gespeicherte Passwörter löschen',
  alsoPermissions: 'Auch Berechtigungen löschen',
  noSiteData: 'Keine gespeicherten Websitedaten.',
  deviceData: 'Daten dieses Geräts (Direkt-Modus)',
  deviceDataHint: 'Im Direkt-Modus liegen Cookies und Cache lokal in diesem Browser. Hier löschst du sie komplett.',
  clearDevice: 'Gerätedaten löschen',
  deletedOk: 'Gelöscht',
  selectedN: 'ausgewählt',
  changePassword: 'Passwort ändern',
  currentPassword: 'Aktuelles Passwort',
  newPassword: 'Neues Passwort (mind. 6 Zeichen)',
  pwChanged: 'Passwort geändert',
  siteInfo: 'Website-Informationen',
  permAsk: 'Fragen',
  permAllow: 'Erlauben',
  permBlock: 'Blockieren',
  clearSiteCookies: 'Cookies und Websitedaten löschen',
  allSiteSettings: 'Alle Website-Einstellungen',
  cookiesCleared: 'Cookies gelöscht',
  noPermsHere: 'Für diese Website gibt es noch keine Entscheidungen.',
  directFailed: 'Der Direkt-Modus kann in diesem Browser nicht starten',
  openInCloudShort: 'Im Cloud-Modus öffnen',
  openInCloud: 'Im Cloud-Modus öffnen (isoliert)',
  directMode: 'Zum Direkt-Modus wechseln (schnell)',
  and: 'und',
  tabs: 'Tabs',
  says: 'meldet',
  connectionLost: 'Verbindung unterbrochen – wird wiederhergestellt',
  unmute: 'Ton einschalten',
  mute: 'Ton ausschalten',
  clearDownloads: 'Leeren',
  backToBrowser: 'Zurück zum Browser',
  openFile: 'Öffnen',
  confirmEnd: 'Wirklich beenden?',
  confirm: 'Bestätigen',
  noneOpen: 'Keine Tabs geöffnet',
  appShort: 'Cloud Browser',
  signInTitle: 'Anmelden',
  registerTitle: 'Konto erstellen',
  permissionsHint: 'Gespeicherte Entscheidungen für Kamera, Mikrofon, Standort und mehr.',
  sessionHint: 'Der Cloud-Browser läuft weiter, auch wenn du dieses Fenster schließt.',
  appName: 'Great Cloud Browser',
  login: 'Anmelden',
  register: 'Konto erstellen',
  noAccount: 'Noch kein Konto?',
  haveAccount: 'Schon ein Konto?',
  logout: 'Abmelden',
  settings: 'Einstellungen',
  newTab: 'Neuer Tab',
  closeTab: 'Tab schließen',
  back: 'Zurück',
  forward: 'Vorwärts',
  reload: 'Neu laden',
  stop: 'Stopp',
  addressPlaceholder: 'Suchen oder Adresse eingeben',
  searchPlaceholder: 'Im Web suchen oder URL eingeben',
  starting: 'Browser wird gestartet …',
  connecting: 'Verbinde …',
  reconnecting: 'Verbindung unterbrochen – verbinde neu …',
  replaced: 'In einem anderen Fenster geöffnet',
  takeOver: 'Hier fortsetzen',
  crashed: 'Der Browser ist abgestürzt und wurde neu gestartet.',
  fallback: 'Kompatibilitätsmodus',
  allow: 'Zulassen',
  block: 'Blockieren',
  remember: 'Entscheidung merken',
  wantsTo: 'möchte',
  'perm.camera': 'deine Kamera verwenden',
  'perm.microphone': 'dein Mikrofon verwenden',
  'perm.geolocation': 'deinen Standort abrufen',
  'perm.notifications': 'Benachrichtigungen anzeigen',
  'perm.clipboard-read': 'deine Zwischenablage lesen',
  'perm.display-capture': 'deinen Bildschirm teilen',
  'kind.camera': 'Kamera',
  'kind.microphone': 'Mikrofon',
  'kind.geolocation': 'Standort',
  'kind.notifications': 'Benachrichtigungen',
  'kind.clipboard-read': 'Zwischenablage',
  'kind.display-capture': 'Bildschirmfreigabe',
  localDenied: 'Dein Gerät hat den Zugriff verweigert.',
  fileWanted: 'möchte eine Datei hochladen',
  chooseFile: 'Datei auswählen',
  chooseFiles: 'Dateien auswählen',
  cancel: 'Abbrechen',
  uploading: 'Wird hochgeladen …',
  downloads: 'Downloads',
  downloadDone: 'Download abgeschlossen',
  save: 'Speichern',
  ok: 'OK',
  leavePage: 'Seite verlassen? Änderungen werden eventuell nicht gespeichert.',
  sitePermissions: 'Website-Berechtigungen',
  noPermissions: 'Noch keine gespeicherten Entscheidungen.',
  allowed: 'Erlaubt',
  blocked: 'Blockiert',
  revoke: 'Widerrufen',
  session: 'Cloud-Sitzung',
  endSession: 'Sitzung beenden',
  endSessionHint: 'Schließt alle Tabs und löscht Cookies und Verlauf dieser Sitzung.',
  account: 'Konto',
  server: 'Server',
  serverUrl: 'Server-Adresse',
  serverHint: 'Adresse deines Cloud-Browser-Servers, z. B. https://cloud.example.com',
  saveServer: 'Speichern & verbinden',
  done: 'Fertig',
  sound: 'Ton',
  enableSound: 'Tippen, um den Ton zu aktivieren',
  fullscreen: 'Vollbild',
  keyboard: 'Tastatur',
  active: 'aktiv',
  stopSharing: 'Beenden',
  copied: 'Im Cloud-Browser kopiert – tippen zum Übernehmen',
  errorGeneric: 'Etwas ist schiefgelaufen.',
  retry: 'Erneut versuchen',
  menu: 'Menü',
  notSecure: 'Nicht sicher',
  secure: 'Sichere Verbindung',
};

type Key = keyof typeof de;

const en: Record<Key, string> = {
  recent: 'Recently visited',
  licenseKey: 'License key',
  licenseKeyHint: 'Required to create an account. Each key works for exactly one account. You do not need it to sign in.',
  lic_required: 'Please enter a license key.',
  lic_not_found: 'This license key is not valid.',
  lic_used: 'This license key has already been used for an account.',
  lic_suspended: 'This license key is paused.',
  lic_revoked: 'This license key was revoked.',
  lic_expired: 'This license key has expired.',
  lic_activation_limit_reached: 'The limit for this license key has been reached.',
  lic_wrong_product: 'This license key belongs to a different product.',
  lic_unreachable: 'The license server is not reachable right now. Please try again shortly.',
  general: 'General',
  browsingMode: 'Browsing mode',
  browsingModeHint: 'Direct loads pages on your device (fast). Cloud runs isolated on the server.',
  modeDirectOpt: 'Direct (fast)',
  modeCloudOpt: 'Cloud (isolated)',
  offerSavePw: 'Offer to save passwords',
  offerFillPw: 'Offer saved credentials for filling',
  passwords: 'Passwords',
  passwordsHint: 'Stored encrypted in your account. In cloud mode, logins are detected automatically.',
  noPasswords: 'No saved passwords yet.',
  addPassword: 'Add password',
  website: 'Website',
  username: 'Username',
  password: 'Password',
  show: 'Show',
  hide: 'Hide',
  copyPw: 'Copy password',
  deleteBtn: 'Delete',
  saveBtn: 'Save',
  updateBtn: 'Update',
  neverBtn: 'Never',
  neverSavedFor: 'Never save for',
  removeBtn: 'Remove',
  savePwQ: 'Save password for',
  updatePwQ: 'Update password for',
  fillAs: 'Fill as',
  pwSaved: 'Password saved',
  siteData: 'Site data',
  siteDataHint: 'Cookies, passwords and permissions per website. Delete the data of selected websites here.',
  cookiesCol: 'Cookies',
  passwordsCol: 'Passwords',
  permissionsCol: 'Permissions',
  deleteSelected: 'Delete selected',
  deleteEverything: 'Delete everything',
  alsoPasswords: 'Also delete saved passwords',
  alsoPermissions: 'Also delete permissions',
  noSiteData: 'No stored site data.',
  deviceData: 'Data on this device (direct mode)',
  deviceDataHint: 'In direct mode, cookies and cache live in this browser. Clear them completely here.',
  clearDevice: 'Clear device data',
  deletedOk: 'Deleted',
  selectedN: 'selected',
  changePassword: 'Change password',
  currentPassword: 'Current password',
  newPassword: 'New password (min. 6 characters)',
  pwChanged: 'Password changed',
  siteInfo: 'Site information',
  permAsk: 'Ask',
  permAllow: 'Allow',
  permBlock: 'Block',
  clearSiteCookies: 'Clear cookies and site data',
  allSiteSettings: 'All site settings',
  cookiesCleared: 'Cookies cleared',
  noPermsHere: 'No decisions for this site yet.',
  directFailed: 'Direct mode cannot start in this browser',
  openInCloudShort: 'Open in cloud mode',
  openInCloud: 'Open in cloud mode (isolated)',
  directMode: 'Switch to direct mode (fast)',
  and: 'and',
  tabs: 'Tabs',
  says: 'says',
  connectionLost: 'Connection lost – reconnecting',
  unmute: 'Unmute',
  mute: 'Mute',
  clearDownloads: 'Clear',
  backToBrowser: 'Back to browser',
  openFile: 'Open',
  confirmEnd: 'End the session?',
  confirm: 'Confirm',
  noneOpen: 'No open tabs',
  appShort: 'Cloud Browser',
  signInTitle: 'Sign in',
  registerTitle: 'Create account',
  permissionsHint: 'Saved decisions for camera, microphone, location and more.',
  sessionHint: 'The cloud browser keeps running when you close this window.',
  appName: 'Great Cloud Browser',
  login: 'Sign in',
  register: 'Create account',
  noAccount: 'No account yet?',
  haveAccount: 'Already have an account?',
  logout: 'Sign out',
  settings: 'Settings',
  newTab: 'New tab',
  closeTab: 'Close tab',
  back: 'Back',
  forward: 'Forward',
  reload: 'Reload',
  stop: 'Stop',
  addressPlaceholder: 'Search or enter address',
  searchPlaceholder: 'Search the web or type a URL',
  starting: 'Starting browser …',
  connecting: 'Connecting …',
  reconnecting: 'Connection lost – reconnecting …',
  replaced: 'Opened in another window',
  takeOver: 'Continue here',
  crashed: 'The browser crashed and was restarted.',
  fallback: 'Compatibility mode',
  allow: 'Allow',
  block: 'Block',
  remember: 'Remember this decision',
  wantsTo: 'wants to',
  'perm.camera': 'use your camera',
  'perm.microphone': 'use your microphone',
  'perm.geolocation': 'know your location',
  'perm.notifications': 'show notifications',
  'perm.clipboard-read': 'read your clipboard',
  'perm.display-capture': 'share your screen',
  'kind.camera': 'Camera',
  'kind.microphone': 'Microphone',
  'kind.geolocation': 'Location',
  'kind.notifications': 'Notifications',
  'kind.clipboard-read': 'Clipboard',
  'kind.display-capture': 'Screen sharing',
  localDenied: 'Your device denied access.',
  fileWanted: 'wants to upload a file',
  chooseFile: 'Choose file',
  chooseFiles: 'Choose files',
  cancel: 'Cancel',
  uploading: 'Uploading …',
  downloads: 'Downloads',
  downloadDone: 'Download complete',
  save: 'Save',
  ok: 'OK',
  leavePage: 'Leave page? Changes you made may not be saved.',
  sitePermissions: 'Site permissions',
  noPermissions: 'No saved decisions yet.',
  allowed: 'Allowed',
  blocked: 'Blocked',
  revoke: 'Revoke',
  session: 'Cloud session',
  endSession: 'End session',
  endSessionHint: 'Closes all tabs and deletes cookies and history of this session.',
  account: 'Account',
  server: 'Server',
  serverUrl: 'Server address',
  serverHint: 'Address of your cloud browser server, e.g. https://cloud.example.com',
  saveServer: 'Save & connect',
  done: 'Done',
  sound: 'Sound',
  enableSound: 'Tap to enable sound',
  fullscreen: 'Fullscreen',
  keyboard: 'Keyboard',
  active: 'active',
  stopSharing: 'Stop',
  copied: 'Copied in the cloud browser – tap to copy',
  errorGeneric: 'Something went wrong.',
  retry: 'Try again',
  menu: 'Menu',
  notSecure: 'Not secure',
  secure: 'Secure connection',
};

const lang = typeof navigator !== 'undefined' && navigator.language?.toLowerCase().startsWith('de') ? 'de' : 'en';
const dict: Record<Key, string> = lang === 'de' ? de : en;

export const t = (k: Key): string => dict[k] ?? k;
/** Turns a server error like 'license_used' into a readable message (other errors pass through). */
export const tError = (msg: string): string => (msg.startsWith('license_') ? (dict[('lic_' + msg.slice(8)) as Key] ?? msg) : msg);
export const tKind = (kind: string) => dict[`kind.${kind}` as Key] ?? kind;
export const tPerm = (kind: string) => dict[`perm.${kind}` as Key] ?? kind;
export const uiLang = lang;
